import { render, staticRenderFns } from "./McMasterAcademicIntegrityV2.vue?vue&type=template&id=ca60e2c4&"
import script from "./McMasterAcademicIntegrityV2.vue?vue&type=script&lang=js&"
export * from "./McMasterAcademicIntegrityV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VForm,VSimpleTable,VTextField})
